<template>
  <div v-if="data" v-cloak>
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-4">
          <p class="watermark" v-html="data.misc.watermark"></p>
          <p v-html="data.login.loginText"></p>
          <div class="row">
            <div class="col-sm"></div>
            <div class="col-sm">
              <label class="text-nowrap" for="ssn" v-html="data.login.ssnLabel"></label>
            </div>
            <div class="col-sm">
              <small class="text-nowrap" v-if="showSsnHelp && !isPhone">
                <strong>Format: YYYYMMDDXXXX</strong>
              </small>
            </div>
          </div>
          <input
            class="form-control text-center form-control-lg ssn"
            type="text"
            name="ssn"
            ref="ssn"
            autocomplete="nope"
            autocapitalize="none"
            inputmode="numeric"
            placeholder="YYYYMMDDXXXX"
            v-model="ssn"
            :disabled="cnmbr !== null && cnmbr.length > 0"
            @keyup.enter="enterKeyHandler()"
            @input="handleSsn($event.target.value)"
          />
          <div class="clearfix"></div>
          <div class="row">
            <div class="col-sm"></div>
            <div class="col-sm">
              <label class="text-nowrap" for="cnmbr" v-html="data.login.cnmbrLabel"></label>
            </div>
            <div class="col-sm">
              <small class="text-nowrap" v-if="showCnmbrHelp && !isPhone">
                <strong>Format: YYYYMMDD(+60)XXXX</strong>
              </small>
            </div>
          </div>
          <input
           class="form-control text-center form-control-lg ssn"
           type="text"
           name="cnmbr"
           ref="cnmbr"
           autocomplete="nope"
           autocapitalize="none"
           inputmode="numeric"
           placeholder="YYYYMMDDXXXX"
           v-model="cnmbr"
           :disabled="ssn !== null && ssn.length > 0"
           @keyup.enter="enterKeyHandler()"
           @input="handleCnmbr($event.target.value)"
          />
          <div class="clearfix"></div>
          <div class="btn-group" role="group" aria-label="">
            <button class="btn btn-primary btn-login btn-sm" @click="loginWithBankId()"
              :disabled="!isSsnValid && !isCnmbrValid">
              {{data.misc.loginBankidBtn}}
              <img src="@/assets/img/bankid.svg?data" class="login-type" alt="BankID logotyp" />
            </button>
            <div class="clearfix--btns"></div>
            <button class="btn btn-primary btn-login btn-sm" @click="loginWithFreja()"
              :disabled="!isSsnValid && !isCnmbrValid">
              {{data.misc.loginFrejaidBtn}}
              <img src="@/assets/img/freja.svg?data" class="login-type" alt="Freja eID logotyp" />
            </button>
          </div>
          <div class="clearfix--min"></div>
          <small class="text-muted" v-html="data.login.loginDisclaimer"></small>
          <div class="clearfix--min"></div>
          <alert class="alert alert-danger" v-show="alert"><span v-html="data.error.errorText"></span></alert>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
    <!-- Modal - More info -->
    <div id="more-info" class="modal fade" role="dialog" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <p v-html="data.login.moreInfoModal"></p>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal - Data protection -->
    <div id="data-protection" class="modal fade" role="dialog" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <p v-html="data.login.dataProtectionModal"></p>
          </div>
        </div>
      </div>
    </div>
    <!-- Cookies notification -->
    <vue-cookie-accept-decline
      :ref="'cookies'"
      :elementId="'cookies'"
      :debug="false"
      :position="'top-left'"
      :type="'floating'"
      :disableDecline="true"
      :transitionName="'slideFromBottom'"
      :showPostponeButton="false">
      <div slot="message">
        Denna sida använder cookies. <br />
        Läs mer <a href="https://www.pts.se/cookies" target="_blank">här</a>.
      </div>
      <div slot="acceptContent">Jag förstår</div>
    </vue-cookie-accept-decline>
  </div>
</template>

<script>
import Alert from '../../src/components/Alert'
import config from '../../config/index.js'
import axios from '../plugins/axios'
import { showDelayText } from '../plugins/delayhandler'
import { request } from '../plugins/datocms'
import { debounce } from '../plugins/debounce'
import { luhnSsn } from '../plugins/luhnssn'
import { isMobile } from 'mobile-device-detect'

export default {
  name: 'login',
  components: {
    Alert
  },
  data () {
    return {
      showSsnHelp: false,
      showCnmbrHelp: false,
      data: null,
      alert: false,
      ssn: null,
      cnmbr: null,
      isPhone: isMobile,
      isDev: process.env.NODE_ENV === 'dev',
      isQa: process.env.NODE_ENV === 'qa'
    }
  },
  methods: {
    clearSessionStorage () {
      var language = sessionStorage.getItem('language')
      sessionStorage.clear()
      const res = {
        ...sessionStorage
      }
      console.log('sessionStorage should be cleared, current: ' + JSON.stringify(res))
      if (language) {
        sessionStorage.setItem('language', language)
      }
    },
    clearLocalStorage () {
      var cookies = localStorage.getItem('vue-cookie-accept-decline-cookies')
      var access = localStorage.getItem('access')
      var pharmacy = localStorage.getItem('pharmacy')
      localStorage.clear()
      const res = {
        ...localStorage
      }
      console.log('localStorage should be cleared, current: ' + JSON.stringify(res))
      if (cookies) {
        localStorage.setItem('vue-cookie-accept-decline-cookies', cookies)
      }
      if (access) {
        localStorage.setItem('access', access)
      }
      if (pharmacy) {
        localStorage.setItem('pharmacy', pharmacy)
      }
    },
    clearStorages () {
      this.clearSessionStorage()
      this.clearLocalStorage()
    },
    loginWithBankId () {
      this.alert = false
      let loader = this.$loading.show({
        default: showDelayText(config.delayText, config.delayTimer)
      })
      const callbackUrl = window.location.origin.concat(config.consentUri)
      const identification = this.ssn ? this.ssn : this.cnmbr
      this.clearStorages()
      axios.postLogin(config.loginUri + config.bankIdUri, identification, callbackUrl).then((response) => {
        if (response) {
          if (response.data.length > 0) {
            loader.hide()
            localStorage.setItem('uri', config.tokenUri + config.bankIdUri)
            window.location.href = response.data
          } else {
            loader.hide()
            this.alert = true
          }
        }
      }, (error) => {
        if (error.response && error.response.status === 401) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        } else {
          loader.hide()
          console.log(error)
        }
      })
    },
    loginWithFreja () {
      this.alert = false
      let loader = this.$loading.show({
        default: showDelayText(config.delayText, config.delayTimer)
      })
      const callbackUrl = window.location.origin.concat(config.consentUri)
      const identification = this.ssn ? this.ssn : this.cnmbr
      this.clearStorages()
      axios.postLogin(config.loginUri + config.frejaUri, identification, callbackUrl).then((response) => {
        if (response) {
          if (response.data.length > 0) {
            loader.hide()
            localStorage.setItem('uri', config.tokenUri + config.frejaUri)
            window.location.href = response.data
          } else {
            loader.hide()
            this.alert = true
          }
        }
      }, (error) => {
        if (error.response && error.response.status === 401) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        } else {
          loader.hide()
          console.log(error)
        }
      })
    },
    handleSsn (input) {
      this.showSsnHelp = true
      if (input) {
        this.ssn = this.ssn.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
      }
    },
    handleCnmbr (input) {
      this.showCnmbrHelp = true
      if (input) {
        this.cnmbr = this.cnmbr.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
      }
    },
    enterKeyHandler () {
      if (this.isSsnValid || this.isCnmbrValid) {
        this.loginWithBankId()
      }
    }
  },
  computed: {
    isCnmbrValid () {
      const cnmbrValid = (luhnSsn(this.cnmbr) && this.cnmbr.length === 12)
      return cnmbrValid
    },
    isSsnValid () {
      const ssnValid = (luhnSsn(this.ssn) && this.ssn.length === 12)
      return ssnValid
    }
  },
  watch: {
    ssn: debounce(function () {
      this.showSsnHelp = false
    }, 1000),
    cnmbr: debounce(function () {
      this.showCnmbrHelp = false
    }, 1000)
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          login(locale: ` + sessionStorage.getItem('language') + `) {
            loginText
            loginDisclaimer
            ssnLabel
            cnmbrLabel
            moreInfoModal
            dataProtectionModal
          }
          misc(locale: ` + sessionStorage.getItem('language') + `) {
            loginBankidBtn
            loginFrejaidBtn
            cookiesText
            watermark
          }
          auth(locale: ` + sessionStorage.getItem('language') + `) {
            phrases
          }
          error(locale: ` + sessionStorage.getItem('language') + `) {
            errorText
          }
        }
      `
    })
    if (!isMobile) {
      this.$nextTick(() => this.$refs.ssn.focus())
    }
    setTimeout(() => { window.scrollTo(0, 0) })
  },
  updated () {
    this.$nextTick(function () {
      const access = localStorage.getItem('access')
      for (const phrase of Object.values(this.data.auth.phrases)) {
        if (access && access === phrase) {
          this.$router.push('/login')
          break
        } else {
          this.$router.push('/')
        }
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  margin-top: 5vh !important;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
small {
  font-size: .7rem;
}
#alert {
  display: none;
}
.alert {
  font-size: .6rem;
  padding-bottom: 0;
}
.text-muted {
  font-size: 11px;
}
.login-type {
  height: 5vh;
}
button:disabled, input:disabled {
  opacity: 0.3;
}
.clearfix--btns {
  margin-left: 1vw;
  margin-right: 1vw;
}
.btn-login {
  border-radius: 20px !important;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .container {
    margin-top: 2vh !important;
    margin-bottom: -6.5vh;
  }
  .login-type {
    height: 4vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue